const parentScaleTypes = {
  competency: 'competency',
  scale: 'scale',
}
export const parentScaleTypeLabels: any = {
  competency: 'Competency',
  scale: 'Scale',
}
export default parentScaleTypes
